import * as types from '../types'



export const homeReqBase = (data) => ({
  type: types.HOME_REQ_BASE,
  data
})

export const homeHandleBase = (data) => ({
  type: types.HOME_HANDLE_BASE,
  data
})

export const homeDetail = (data) => ({
  type: types.HOME_DETAIL,
  data
})

export const homeHandle = (data) => ({
  type: types.HOME_HANDLE,
  data
})

export const homeReward = (data) => ({
  type: types.HOME_REWARD,
  data
})

export const homeHandleReward = (data) => ({
  type: types.HOME_HANDLE_REWARD,
  data
})


export const homeRecTask = (data) => ({
  type: types.HOME_REC_TASK,
  data
})

export const homeHandleTask = (data) => ({
  type: types.HOME_HANDLE_TASK,
  data
})

